import { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from 'src/hooks/app';
import {
    CollectionActions,
    collectionFetchThunk,
    selectCollection,
    selectCollectionEntities
} from '../ducks';

export const useCollection = () => useAppSelector(selectCollection);

export const useFetchCollection = () => {
    const dispatch = useAppDispatch();

    return useCallback(async (id: string) => {
        const res = await dispatch(collectionFetchThunk(id));
        return res;
    }, [dispatch]);
};

export const useCollectionClear = () => {
    const dispatch = useAppDispatch();

    return useCallback(() => {
        dispatch(CollectionActions.clearCollection());
    }, [dispatch]);
};

export const useCollectionById = (id: string) => {
    const byId = useAppSelector(selectCollectionEntities);
    return byId[id];
};
